export const meta = {
  title: '会员忠诚:积分、等级,和让人回头的代金券',
  updatedAt: '2026-07-17',
  related: ['pos', 'promotions', 'getting-started'],
};

忠诚体系自己运转:顾客每完成一单就赚积分,积分推着他们爬等级,等级带来自动折扣。留给您的是有趣的部分——决定什么时候发代金券。

## 积分怎么赚

单子完成取车并付款的那一刻,顾客按**每消费 RM 1 得 1 分**入账(向下取整——RM 49.90 记 49 分)。只有登录的顾客才能积分;没有顾客账号的散客单一分不得——这正是引导熟客扫您二维码的好理由。

积分倍率,以及可选的按车型倍数和繁忙时段加成,都属于您的忠诚配置——目前以合理的默认值发货,自助调整的设置页面即将推出。

## 等级阶梯

等级按**累计积分**排定——永不清零:

- **青铜**——起始等级,0 分起。
- **白银**——累计 500 分起。特权:**每次洗车 95 折**,在 POS 自动生效。
- **黄金**——累计 2,000 分起。特权:**每次洗车 9 折**,外加排队优先标记。

哪一单把顾客送上更高等级,祝贺通知当场送达——真实的里程碑,在发生的那一刻庆祝。

一句实话:积分是驱动等级的累计分数,不能消费或兑换——积分换礼目录还没有。

## 顾客看到什么

顾客应用主屏幕有一张会员卡——等级徽章、累计积分、升级进度条——还有完整的会员页:积分余额、整条等级阶梯、每级解锁的全部特权。这条阶梯替您做营销:_"还差 212 分升黄金"_,比任何海报都更能卖出下一次洗车。

## 代金券

代金券是您发给特定顾客的一次性折扣。在代金券页面搭建可复用的**模板**:名称、折扣——整单**按 % 减**或**按 RM 减**——每位顾客最多可领几张、每张发出后有效多少天(默认 30 天)。模板支持定向:最低等级、仅限新客、或带特定标签的顾客。模板随时可暂停;已发出的代金券不受影响。

模板绝不会自己触发——**每张代金券都由您亲手发出**,入口有两个:

- **顾客**页面——选顾客,选模板;
- **POS**——一场漂亮的洗车之后当场发,趁顾客还在笑。

顾客在应用钱包里看到代金券和它的有效期。核销发生在柜台:收银员在 POS 付款单上点选代金券,折扣单独占一行落账。

## 忠诚体系还没有的

跟您说实话:还没有**集章卡**("洗十送一"),没有**成就引擎**,没有**生日礼遇**——也没有可以修改积分倍率或等级门槛的后台页面,这些目前按上文描述的默认值运行。已上线的正是本页所写:取车即积分、三级阶梯带自动折扣、手动发放的代金券。相关但独立:自动**促销**(欢乐时光、指定星期)和**预付洗车包**在促销菜单下各有各的工具——促销现在在本手册里有了自己的文章。
